// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Gender } from './gender.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PlpAccountRegisterAccount {
    'firstName': string;
    'lastName': string;
    'zip': string;
    'dob': string;
    'gender': Gender;
    'email': string;
    'password': string;
    'confirmPassword': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PlpAccountRegisterAccount>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "zip",
            "baseName": "zip",
            "type":     "string"
        },
        {
            "name":     "dob",
            "baseName": "dob",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "Gender"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "password",
            "baseName": "password",
            "type":     "string"
        },
        {
            "name":     "confirmPassword",
            "baseName": "confirmPassword",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PlpAccountRegisterAccount.attributeTypeMap;
    }
}
